import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function _3dRotationIcon(props: IconProps) {
    return <Icon {...props} iconKey={"3d_rotation"}/>
}
